const GRAMMAGE = 135;
const VOLUME_FACTOR = 1.3;

export function getStackHeightInMM(pages: number): number {
  return ((pages / 2) * GRAMMAGE * VOLUME_FACTOR) / 1000;
}
